<ion-app [class.dark-theme]="dark">
  <ion-split-pane contentId="main-content">
    <ion-router-outlet id="main-content" />
  </ion-split-pane>

  <!-- Menü-Komponente für mobile Ansicht -->
  <ion-menu *ngIf="false" side="start" contentId="main-content" menuId="first-menu">
    <ion-header>
      <ion-toolbar class="menutoolbar">
          <ion-img
            (click)="navigateToHome()"
            src="assets/images/newDesign/Logo_00_Termed_Logo_Blau.png"
            alt="Termed Logo"
            class="menu-logo"
          ></ion-img>
          <ion-buttons slot="end">
            <ion-menu-toggle>
              <ion-button class="buttonblue" (click)="closeStartMenu()"><ion-icon name="close"></ion-icon></ion-button>
            </ion-menu-toggle>
          </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-row  class="termedlightbg padding">
        <ion-col size="6">
          <ion-button color="success" expand="block" (click)="navigateToLogin()">
            Patient
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button color="success" expand="block">
            Praxis
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-accordion-group class="termedlightbg padding">
        <ion-accordion value="first">
          <ion-item slot="header" color="light">
            <ion-label (click)="navigateToPage('Produkte')"><p class="accheader">Produkte</p></ion-label>
          </ion-item>
          <div class="termedlightbg" slot="content">
            <ion-item color="light" (click)="navigateToPage('produkt1')">
              <ion-icon name="calendar-outline" slot="start" class="termedblau"></ion-icon>
              <ion-label color="primary"><p><b>TerMed Onlineterminierung</b></p><p>Lassen Sie Ihre Patienten schnell und unkompliziert online Termine vereinbaren</p></ion-label>
            </ion-item>
            <ion-item color="light" (click)="navigateToPage('produkt3')">
              <ion-icon name="call-outline" slot="start" class="termedblau"></ion-icon>
              <ion-label color="primary"><p><b>VIOMEDI</b></p><p>Nutzen Sie die fortschrittliche Praxis-Patientenkommunikation und bieten Sie damit zeitgemäße Services für Ihre Patienten</p></ion-label>
            </ion-item>
            <ion-item color="light" (click)="navigateToPage('produkt2')">
              <ion-icon name="videocam-outline" slot="start" class="termedblau"></ion-icon>
                <ion-label color="primary"><p><b>Hotline</b></p><p>Wir unterstützen Sie gerne durch Fachpersonal an Ihrer Telefonhotline</p></ion-label>
              </ion-item>
          </div>
        </ion-accordion>
        <ion-accordion value="second">
          <ion-item slot="header" color="light" >
            <ion-label click="navigateToPage('aboutus')"><p class="accheader">Über Uns</p></ion-label>
          </ion-item>
        </ion-accordion>
        <ion-accordion value="third">
          <ion-item slot="header" color="light" >
            <ion-label click="navigateToPage('aboutus')"><p class="accheader">Karriere</p></ion-label>
          </ion-item>
        </ion-accordion>
      </ion-accordion-group>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button shape="round" fill="clear" (click)="openLink('https://www.instagram.com/termed_arzttermine_online/')">
            <ion-icon name="logo-instagram"></ion-icon>
          </ion-button>
          <ion-button shape="round" fill="clear" (click)="openLink('https://www.facebook.com/share/198UDYGixe/?mibextid=LQQJ4d')">
            <ion-icon name="logo-facebook"></ion-icon>
          </ion-button>
          <ion-button shape="round" fill="clear" (click)="openLink('https://de.linkedin.com/')">
            <ion-icon name="logo-linkedin"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button color="second" (click)="navigateToPage('Kontakt')">
            Kontaktieren Sie uns
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>

  <!-- Menu Web -->
  <ion-menu *ngIf="isMobile && !environment.apptemp" contentId="main-content" class="mainnav" menuId="main-menu">
    <ion-header>
      <ion-toolbar class="menutoolbar">
        <ion-button 
          fill="empty"
          (click)="navigateToHome()"
          [attr.aria-label]="'app-component.buttons.aria-label.logo' | translate"
          class="menu-home-button-logo"
        />
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <!-- Menu Web: Patient -->
      <ion-list >
        <ng-content *ngFor="let pp of pagesPatient">
          <ion-item 
            button 
            *ngIf="!hiddenNavElement(pp,1)"
            (click)="openPage($event, pp)" 
            routerLinkActive="selected"
            routerDirection="root" 
            detail="false" 
          >
            <ion-icon color="primary" *ngIf="pp.icon !== null" name="{{pp.icon}}" slot="start"></ion-icon>
            <ion-label>{{pp.title | translate }}</ion-label>
          </ion-item>
        </ng-content>
      </ion-list>

      <!-- Menu Web: Footer -->
      <ion-list *ngFor="let pf of pagesFootage">
        <ion-item 
          button
          (click)="openPage($event, pf)" 
          routerLinkActive="selected"
          routerDirection="root" 
          detail="false" 
          *ngIf="!hiddenNavElement(pf,3)"
        >
          <ion-icon color="primary" *ngIf="pf.icon !== null" name="{{pf.icon}}" slot="start"></ion-icon>
          <ion-label>{{pf.title | translate }}</ion-label>
        </ion-item>
      </ion-list>

      <ion-item lines="none"></ion-item>

      <!-- Menu Web: Footer - another Footer -->
      <ion-footer>
        <!-- Menu Web: Language Settings -->
        <ion-row>
          <ion-col size="5">
            <ion-item lines="none">
              <ion-label>{{ 'language' | translate }}</ion-label>
            </ion-item>
          </ion-col>
          <ion-col size="3">
            <ion-button 
              fill="empty" 
              [attr.aria-label]="'app-component.buttons.aria-label.lang.de' | translate"
              (click)="translateLanguageTo('de')" 
              class="change-language-menu-button de" 
            />
          </ion-col>
          <ion-col size="3">
            <ion-button 
              fill="empty"
              [attr.aria-label]="'app-component.buttons.aria-label.lang.en' | translate"
              (click)="translateLanguageTo('en')"
              class="change-language-menu-button en" 
            />
          </ion-col>
        </ion-row>

        <!-- Menu Web: Sub Navigation -->
        <ion-row>
          <ion-col class="footernav" *ngFor="let pl of pagesLegals">
            <a
              class="navli" 
              [attr.href]="pl.href" 
              (click)="openPage($event, pl)"
              [ngClass]="{'separate': pl.separate, 'hidden': (hiddenNavElement(pl,3))}"
            >
              {{pl.title | translate }} 
          </a>
          </ion-col>
        </ion-row>

        <div class="footernav" *ngFor="let pl of pagesLegals"></div>

        <!-- Menu Web: Appversion -->
        <ion-row>
          <ion-item lines="none">
            <p>Version: 2.0.{{AppSettings.CACHE_VERSION}}</p>
          </ion-item>
        </ion-row>
      </ion-footer>
    </ion-content>
  </ion-menu>

  <!-- Apptemp -->
  <ion-tabs *ngIf="environment.apptemp" >
    <ion-tab-bar slot="bottom" color="tertiary">
      <ion-tab-button tab="suche">
        <ion-icon name="search"></ion-icon>
        <ion-label>{{ 'pages.pat_search' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="dashboard">
        <ion-icon name="calendar-outline"></ion-icon>
        <ion-label>{{ 'appointments' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="patmedlist">
        <ion-icon name="newspaper-outline"></ion-icon>
        <ion-label>{{ 'med' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="favourites">
        <ion-icon name="heart"></ion-icon>
        <ion-label>{{ 'fav' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="einstellungen">
        <ion-icon name="person-circle-outline"></ion-icon>
        <ion-label>{{ 'profile' | translate }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</ion-app>

